import { LegalPage } from "@/components/LegalPage";

export default function Terms() {
  return <LegalPage page="terms" testId="terms-page" />;
}
